import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import {
  updateEntityRequest,
  receiveEntityResponse,
  receiveUpdatedEntityResponse,
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
} from '../EntityActions';

const ENTITY_LIST_NAME = 'wedding_party_members';

export const editWeddingPartyMember = member => dispatch => {
  dispatch(editEntityRequest(member));
};

export function addWeddingPartyMember(createWeddingPartyMemberFormRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/wedding-party/member/create', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(createWeddingPartyMemberFormRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Wedding Party Member Added' })));
  };
}

export function updateWeddingPartyMember(updateWeddingPartyMemberFormRequest) {
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/wedding-party/member/update', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(updateWeddingPartyMemberFormRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveUpdatedEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: 'Wedding Party Member Updated' })));
  };
}

// SvcWebApiClient.cms.getCmsWeddingParty(id)
export function getWeddingPartyMembers() {
  return dispatch => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/wedding-party', {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(json => {
        dispatch(getEntitiesResponse(json[ENTITY_LIST_NAME]));
        return json;
      });
  };
}
